module.exports = __webpack_public_path__ + "static/media/create.a7a7ac97.svg";